import React from "react";
import { Box, IconButton, Typography } from "@material-ui/core";
import { InsertDriveFile, GetApp } from "@material-ui/icons";
import PropTypes from "prop-types";

import { useStyles } from "./DownloadButton.styles";

function DownloadButton({ type, title, subtitle, onDownload }) {
  const classes = useStyles();

  return (
    <Box
      display="flex"
      flexDirection="row"
      className={classes.downloadWrapper}
      mb={1}
      padding={0.5}
      alignItems="center"
      justifyContent="space-between"
    >
      <Box display="flex" flexDirection="row" alignItems="center">
        <InsertDriveFile className={classes.fileIcon} />
        <Typography variant="body1" className={classes.downloadLabel}>
          {title}
          {subtitle && ` (${subtitle})`}
        </Typography>
      </Box>
      <IconButton
        onClick={() => {
          onDownload(type);
        }}
        aria-label="download"
      >
        <GetApp className={classes.downloadIcon} />
      </IconButton>
    </Box>
  );
}

DownloadButton.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  onDownload: PropTypes.func,
  type: PropTypes.string,
};

export { DownloadButton };
